import React, { createContext, ReactNode, useContext, useState } from 'react';

interface VersionAssetsPaginationContextType {
  currentPage: number;
  setCurrentPage: (pageNumber: number) => void;
  itemsPerPage: number;
  setItemsPerPage: (pageSize: number) => void;
  sortOrder: 'asc' | 'desc';
  setSortOrder: (sortOrder: 'asc' | 'desc') => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  searchQuery: string;
  setSearchQuery: (searchKeyword: string) => void;
  assetTypes: string[];
  setAssetTypes: (types: string[]) => void;
}

const VersionAssetsPaginationContext = createContext<
  VersionAssetsPaginationContextType | undefined
>(undefined);

export const ArtifactVersionPaginationProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [sortBy, setSortBy] = useState<string>('fileName');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [assetTypes, setAssetTypes] = useState<string[]>([]);

  return (
    <VersionAssetsPaginationContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        itemsPerPage,
        setItemsPerPage,
        sortOrder,
        setSortOrder,
        sortBy,
        setSortBy,
        searchQuery,
        setSearchQuery,
        assetTypes,
        setAssetTypes
      }}
    >
      {children}
    </VersionAssetsPaginationContext.Provider>
  );
};

export const useVersionAssetsPaginationContext = (): VersionAssetsPaginationContextType => {
  const context = useContext(VersionAssetsPaginationContext);
  if (!context) {
    throw new Error(
      'useVersionAssetsPaginationContext must be used within a ArtifactVersionPaginationProvider'
    );
  }
  return context;
};
